import { DAILY_PROMOS_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = [];

export default function dailyPromos(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case DAILY_PROMOS_FETCHED:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
